<template>
  <div class="inspection">
    <a
      :class="{hasSecondaryAddress: inspection.address2}"
      class="detail-card"
      @click="goToInspection">

      <div class="image hero" :style="heroImageStyle">
        <img v-if="inspection.companyLogo" class="logo" :src="inspection.companyLogo" />
      </div>

      <div class=details>
        <span class="detail-link btn-primary">
          Inspection Details
        </span>

        <div class="highlight street text-primary">
          {{inspection.address1}}
        </div>
        <div v-if="inspection.address2" class="street-secondary">
          {{inspection.address2}}
        </div>

        <span class="location">
          {{addressLocalityString}}
        </span>

        <div class="highlight date">
          <span
            v-if="inspection.uploadDate">
            Last updated&#58; {{date(inspection.uploadDate)}}
          </span>
        </div>

        <div v-if="inspection.reportId" class="report-id">
          ID: {{inspection.reportId}}
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import { Mixins } from '@homegauge/vue';

const { DateTime } = Mixins;

export default {
  props: {
    inspection: {
      type: Object,
      required: true,
    },
  },
  mixins: [DateTime],
  computed: {
    addressLocalityString() {
      const output = [];
      if (this.inspection.city) {
        output.push(
          this.inspection.city && (this.inspection.state || this.inspection.postalCode)
            ? `${this.inspection.city},`
            : this.inspection.city,
        );
      }
      if (this.inspection.state) {
        output.push(this.inspection.state);
      }
      if (this.inspection.postalCode) {
        output.push(this.inspection.postalCode);
      }
      return output.join(' ');
    },
    heroImageStyle() {
      return {
        backgroundImage: `url(${this.inspection.reportCoverImage})`,
      };
    },
    inspectionLink() {
      return `/inspection/${this.inspection.id}`;
    },
  },
  methods: {
    goToInspection() {
      this.$router.push({
        name: 'inspection',
        params: {
          folderId: `${this.inspection.id}`,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';
@import '../../styles/vars/typography';

.image {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.inspection {
  flex: 0 1 485px;
  margin-left: 33px;
  margin-top: 70px;
  position: relative;
  display: flex;
  justify-content: center;
  width: 960px;
  max-width: 100%;
}

.detail-card {
  background: $theme-color-white;
  border: none;
  box-shadow: 0 8px 24px 0 rgba($theme-color-black, 0.1);
  cursor: pointer;
  display: block;
  min-height: 615px;
  padding-bottom: 40px;
  transition: 0.2s box-shadow, 0.2s transform;
  width: 100%;

  &:hover {
    box-shadow: 0 4px 12px rgba($theme-color-black, 0.25);
    transform: translateY(-5px);
  }

  &.hasSecondaryAddress {
    .date {
      margin-top: 38px;
    }
  }
}

.hero {
  min-height: 275px;
  width: 100%;
}

.details {
  color: rgba($theme-color-black, 0.75);
  margin-top: 80px;
  text-align: center;
}

.location {
  font-size: 1.214rem;
  font-weight: $typography-weight-bold;
}

.text-primary {
  font-size: 2.143rem;
}

.date {
  font-size: 1.214rem;
  margin-top: 70px;
  padding-bottom: 30px;
}

.highlight {
  font-family: $typography-font-secondary;
  font-weight: $typography-weight-bold;
}

.street {
  padding: 0 0 0px;

  &-secondary {
    display: block;
    font-family: $typography-font-secondary;
    font-size: 2rem;
    font-weight: $typography-weight-bold;
  }
}

.detail-link {
  display: block;
  font-size: 1.286rem;
  margin: 40px auto 30px;
  padding: 10px 0 10px 0;
  text-align: center;
  text-transform: uppercase;
  width: 250px;
}

.logo {
  left: 0;
  margin: auto;
  max-height: 100px;
  position: absolute;
  right: 0;
  top: 235px;
}

@media all and (max-width: 1195px) {
  .inspection {
    margin-left: 5px;
    margin-right: 5px;
  }
}

@media all and (max-width: 655px) {
  .date {
    font-size: 4vw;
  }

  .inspection {
    flex: 0 0 100%;
  }

  .text-primary {
    font-size: 6vw;
  }
}
</style>
